import { useState } from 'react';
import { useEffect } from 'react';
import useRequest, { FetchFn, FetchResult } from './useRequest';

interface FindSupplierData {
  Identification: string;
}

interface Supplier {
  SupplierCode: string;
  SupplierName: string;
}

type FindSupplier = Supplier[];

function useFindSupplier(data: FindSupplierData): [FetchFn, FetchResult<Supplier> & { error?: { message: string } }] {
  const { Identification } = data;
  const [supplier, setSupplier] = useState<Supplier | undefined>();
  const [error, setError] = useState<{ message: string } | undefined>();

  const [findSupplier, result] = useRequest<FindSupplier>('FindSupplier', {
    params: `Identification=${Identification}`,
    skip: true,
  });

  useEffect(() => {
    const foundSupplier = result.data?.[0];
    if (result.loading) {
      setError(undefined);
      setSupplier(undefined);
    } else if (foundSupplier) {
      setSupplier(foundSupplier);
    } else if (result.called) {
      setSupplier(undefined);
      setError({ message: `تامین کننده‌ای با شناسه ${Identification} یافت نشد.` });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result.called, result.data, result.loading]);

  return [findSupplier, { ...result, data: supplier, error }];
}

export default useFindSupplier;
